export default __webpack_public_path__ + "static/media/rarity-1.24b7f521.png";